import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver
} from "@angular/core";
import {
  NgxGalleryOptions,
  NgxGalleryImage,
  NgxGalleryAnimation
} from "ngx-gallery";

@Component({
  selector: "app-export-csv",
  templateUrl: "./export-csv.component.html",
  styleUrls: ["./export-csv.component.css"],
  providers: []
})
export class ExportCsvComponent {
  constructor() { }

  fileToUpload: File = null;

  ngOnInit(): void { }

  handleFileInput(files) {
    console.log(files);
    // var files = e.target.files;

    var reader = new FileReader();

    reader.onload = function (e) {
      console.log(e);
      console.log((reader.result as string).split(/\r\n|\n/));
      var csvArr = (reader.result as string).split(/\r\n|\n/);
      var formatedCsvArr = csvArr.map(item => {
        return item.split(",");
      });
      console.log(formatedCsvArr);
    };

    reader.readAsText(files[0]);
  }

  uploadFileToActivity() { }
}



// WEBPACK FOOTER //
// /app/src/app/extras/export-csv/export-csv.component.ts